<template>
      <div class="group-messages-container">
        <div class="ui-block posts-container">
          <div class="comment-form inline-items">
            <div
              class="post__author author vcard inline-items"
              v-if="isMember"
              @keyup.enter.exact="sendMessage"
              @keydown.enter.exact.prevent
            >
              <SUserAvatar :myUser="loggedUser" size="small" :isProfileAvatar="false" :tryModeratorBadge="true"/>

              <div class="form-group with-icon-right padding-l">
                <TextArea
                  v-model="text"
                  placeholder="Write your message here…"
                  ref="messageField"
                  data-cy="chatGroup"
                  @hook:mounted="focusInput()"
                />
              </div>
            </div>

            <SButton
              class="btn btn-blue btn-md-2 btn-size"
              text="POST IT"
              @button="sendMessage"
              :mousedownPrevent="true"
              v-if="isMember"
              data-cy="postMessage"
            />
            <p v-if="!isMember" class="d-flex justify-content-center bold">
              To post messages in this group, you must first be a member.
            </p>
          </div>
        </div>
        <div
          class="ui-block message-list-container"
          v-if="isMember || getCurrentGroup.privacy === group_privacy.PUBLIC"
        >
          <ul>
            <div
              v-for="memberMessage in getCurrentGroupMessages.slice().reverse()"
              :key="memberMessage._id"
              class="post-container"
            >
              <GroupMessagesList :member="memberMessage" />
            </div>
          </ul>
        </div>
      </div>
</template>

<script>
import UserHelperVue from "../../mixins/UserHelper.vue";
import TextArea from "@/components/atoms/TextArea";
import GroupMessagesList from "@/components/molecules/GroupMessagesList";
import GroupHelperVue from "../../mixins/GroupHelper.vue";
import SButton from "@/components/atoms/SButton";
import groupPrivacy from "@/enum/group-privacy";
import SUserAvatar from "@/material-components/atoms/SUserAvatar";
export default {
  name: "GroupMessages",
  mixins: [UserHelperVue, GroupHelperVue],
  components: {
    TextArea,
    GroupMessagesList,
    SButton,
    SUserAvatar,
  },
  data() {
    return {
      text: "",
      group_privacy: groupPrivacy,
    };
  },
  computed: {
    isMember() {
      return !!(this.myGroups.some((group) => group.groupId === this.getCurrentGroup.id));
    },
  },
  methods: {
    sendMessage() {
      try {
        this.sendGroupMessage({
          group: this.getCurrentGroup,
          message: this.text,
        });
        this.text = "";
      } catch (error) {
        console.log(error);
      }
    },
    focusInput() {
      this.$refs.messageField.focus();
    },
  },
  created() {
    this.fetchMessages(this.$route.params.id);
    this.fetchComments(this.$route.params.id);
  },
};
</script>

<style scoped>
.group-messages-container {
  flex: 0 0 calc(100% - 260px);
  padding: 0 8px;
}
.padding-l {
  padding-left: 0.5rem;
}

.avatar-container {
  margin-right: 10px;
  position: relative;
}
.posts-container {
  margin-bottom: 16px;
}
.message-list-container {
  background-color: unset !important;
  border: unset !important;
}
.post-container {
  margin-bottom: 16px;
  background-color: white;
}

.btn-primary {
  margin: unset;
}
.btn-size {
  width: 200px;
}
@media screen and (max-width: 1024px) {
  .group-messages-container {
  flex: 0 0 100%;
}
}
</style>
